import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import RadioField from '../FormLegacy/FormFieldsV2/RadioField'

const EditEventSchedule = ({ onChange, value, formName }) => {
  const { t } = useTranslation(['calendar'])
  const handleChange = (val) => {
    onChange({ target: { value: val } })
  }

  return (
    <React.Fragment>
      <div>{t('calendar:editEventSchedule.intro')}</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
        <RadioField
          type="radio"
          name={`${formName}-eventsToUpdate`}
          value={'false'}
          label={t('calendar:editEventSchedule.updateOnlyThisEvent')}
          onChange={(e) => handleChange(e.target.value)}
          checked={String(value) === 'false'}
        />
        <RadioField
          type="radio"
          name={`${formName}-eventsToUpdate`}
          value={'future'}
          label={t('calendar:editEventSchedule.updateAllFutureEvents')}
          onChange={(e) => handleChange(e.target.value)}
          checked={String(value) === 'future'}
        />
        <RadioField
          type="radio"
          name={`${formName}-eventsToUpdate`}
          value={'true'}
          label={t('calendar:editEventSchedule.updateAllEvents')}
          onChange={(e) => handleChange(e.target.value)}
          checked={String(value) === 'true'}
        />
      </div>
    </React.Fragment>
  )
}

EditEventSchedule.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  formName: PropTypes.string,
}

export default EditEventSchedule
